import { render, staticRenderFns } from "./MCPLogoIcon.vue?vue&type=template&id=17dffd24"
import script from "./MCPLogoIcon.vue?vue&type=script&lang=js"
export * from "./MCPLogoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports